export function playerDeliveryState(order) {
  if (order.status === "delivered") return "delivered";
  if (["cancelled", "failed"].includes(order.status)) return order.status;
  const reviewStatus = order.review_approval?.status || order.review_status;
  if (order.player_approval_pending && reviewStatus === "sent_for_review" && !order.review_plan_changed) return "review_needed";
  if (order.delivery_address_complete === false || order.blockers?.some((row) => row.category === "delivery_address")) return "address_needed";
  if (order.status === "shipping_expected") return "shipping";
  if (order.status === "ordered") return "ordered";
  return "organizing";
}

export function playerDeliveryDate(value, lang) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return "–";
  return new Intl.DateTimeFormat(lang === "de" ? "de-DE" : "en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" }).format(new Date(`${value}T12:00:00Z`));
}
